<template>
    <div>
        <v-card raised>
            <v-card-title>
                Replace Lost Hang Tag
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="customers" :loading="loadingCustomers" :search="search" class="elevation-1">
                    <template v-slot:header.permit_number>
                        <v-icon small>mdi-pencil</v-icon> Permit Number
                    </template>
                    <template v-slot:item.permit_number="props">
                        <v-edit-dialog :return-value.sync="props.item.name" @save="save(props.item)" @cancel="cancel" @open="open" @close="close"
                        > {{ props.item.permit_number }}
                            <template v-slot:input>
                                <v-text-field v-model="props.item.new_permit_number" label="Edit" single-line counter></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingCustomers: false,
                loadingSubmitButton: false,
                customers: [],
                effectiveDateMenu: false,
                expirationDateMenu: false,
                editedIndex: -1,
                snack: false,
                snackColor: '',
                snackText: '',
                headers: [
                    { text: 'Customer Name', align: 'left', sortable: true, value: 'customer_name',},
                    { text: 'UIN', value: 'uin' },
                    { text: 'Permit Number', value: 'permit_number' },
                    { text: 'Permit Series', value: 'permit_number_series_code', sortable: true },
                ],
            }
        },
        created() {
            this.fetchPermitRates();
        },
        methods: {
            fetchPermitRates: function () {
                this.loadingCustomers = true;
                axios.get(this.appURL + '/api/losthangtag')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            var data = response.data;
                            var addNewPermit = data.map(function(permit) {
                                var permits = Object.assign({}, permit);
                                permits.new_permit_number = '';
                                return permits;
                            });
                            this.customers = addNewPermit;
                        }
                        this.loadingCustomers = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingCustomers = false;
                    });
            },
            save: function(item) {
                //Update
                this.editedIndex = this.customers.indexOf(item);
                this.loadingSubmitButton = true;
                axios.post(this.appURL + '/api/losthangtag/' + item.permit_number, {
                    _method: 'patch',
                    uin: item.uin,
                    permit_number: item.permit_number,
                    new_permit_number: item.new_permit_number,
                    permit_number_series_code: item.permit_number_series_code,
                }).then((response) => {
                    if(response.status === 200)
                    {
                        item.permit_number = item.new_permit_number;
                        Object.assign(this.customers[this.editedIndex], item)
                        this.snack = true;
                        this.snackColor = 'success';
                        this.snackText = 'Successfully Updated';
                    }
                    else {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!';
                    }
                    this.loadingSubmitButton = false;
                    this.close()
                }).catch(error => {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = 'Oops! Something went wrong!';
                    this.loadingSubmitButton = false;
                    this.close()
                });
            },
            cancel () {
            },
            open () {
            },
            close () {
            },
        }
    }
</script>
